import React from 'react';
import {motion} from "framer-motion";

const CreateSeriesButton = ({ children, handleSubmit, variant = 'default', className = '', ...props }) => {
    const baseStyle = 'px-4 py-2 rounded-lg font-medium transition-colors duration-200';
    const variantStyles = {
        default: 'bg-indigo-600 text-white hover:bg-indigo-700',
        outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
        ghost: 'text-gray-700 hover:bg-gray-100',
    };
    return (
            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`${baseStyle} ${variantStyles[variant]} ${className}`}
                onClick={handleSubmit}
                {...props}
            >
                {children}
            </motion.button>

);
};

export default CreateSeriesButton;
